import {
  queryOptions,
  useSuspenseQueries,
  useSuspenseQuery,
} from "@tanstack/react-query";
import { create, keyResolver, windowScheduler } from "@yornaath/batshit";
import type { PurchaseOffer } from "shared";
import { Api } from "@/api.config";
import { QueryKeys } from "@/LinkGen";

const batcher = create({
  fetcher: async (IDs: number[]) => Api.PurchaseOffers(IDs),
  resolver: keyResolver("ID"),
  scheduler: windowScheduler(50),
});

function purchaseOfferQueryOptions(
  purchaseID: number,
  ID: number | null | undefined,
) {
  return queryOptions({
    queryKey: QueryKeys.Purchase.Offer(purchaseID, ID),
    queryFn: () => {
      if (!ID) {
        return null;
      }

      return batcher.fetch(ID);
    },
  });
}

export function useSuspensePurchaseOffer(
  purchaseID: number,
  ID: number | null | undefined,
): PurchaseOffer | null {
  const { data } = useSuspenseQuery(purchaseOfferQueryOptions(purchaseID, ID));

  return data;
}

export function useSuspensePurchaseOfferList(
  purchaseID: number,
  offerIDs: number[],
) {
  const data = useSuspenseQueries({
    queries: offerIDs.map((ID) => purchaseOfferQueryOptions(purchaseID, ID)),
  });

  return data.map((x) => x.data as PurchaseOffer);
}
